import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import Loader from '../../Components/Loader';

import icon2 from "../../Images/Icon/63.png";

import MensajesHelper from '../../Helpers/Mensajes';

const View = () => {
    const [mensajes, setMensajes] = useState([]);
    const [flag, setFlag] = useState(false);

    useEffect(() => {
        obtenerMensajes();
    }, []);

    const obtenerMensajes = async () => {
        let res = await MensajesHelper.obtenerMensajes();
        if (res.success) {
            setMensajes(res.data);
            setFlag(true);
        } else {
            Swal.fire(
                'Error!',
                'No se lograron obtener los mensajes, codigo: ' + res.code,
                'error'
            );
        }
    };

    const eliminarMensaje = id => {
        MensajesHelper.eliminarMensaje(id);
    };

    return (
        <div id='vistas_generales' className='col s12' style={{ padding: "0" }}>
            <div className='container center'>
                <p className='titulo_solicitud' style={{ textAlign: "center" }}>
                    Mensajes del sitio
                </p>
                {!flag ? (
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "60vh" }}>
                        <Loader />
                    </div>
                ) : (
                    <div>
                        <div className='row' style={{ marginLeft: "25px", fontWeight: "bold" }}>
                            <div className='col s2'><p>Nombre</p></div>
                            <div className='col s2'><p>Email</p></div>
                            <div className='col s2'><p>Celular</p></div>
                            <div className='col s3'><p>Mensaje</p></div>
                            <div className='col s1'><p>Pago</p></div>
                            <div className='col s2'><p>Acciones</p></div>
                        </div>
                        {mensajes.map(mensaje => (
                            <div className='box_solicitud' key={mensaje._id}>
                                <div className='row'>
                                    <div className='col s2'>
                                        <p className='texto_solicitud'>{mensaje.nombre}</p>
                                    </div>
                                    <div className='col s2'>
                                        <p className='texto_solicitud'>{mensaje.email}</p>
                                    </div>
                                    <div className='col s2'>
                                        <p className='texto_solicitud'>{mensaje.celular}</p>
                                    </div>
                                    <div className='col s3'>
                                        <p className='texto_solicitud'>{mensaje.mensaje}</p>
                                    </div>
                                    <div className='col s1'>
                                        <p className='texto_solicitud'>{mensaje.pago}</p>
                                    </div>
                                    <div className='col s2'>
                                        <img
                                            style={{ cursor: "pointer" }}
                                            onClick={() => { eliminarMensaje(mensaje._id); }}
                                            src={icon2}
                                            alt="eliminar"
                                        />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default View;
